var $ef2ace7c082abe42$exports = {};
$ef2ace7c082abe42$exports = {
    "more": `M\xe1s elementos`
};


export {$ef2ace7c082abe42$exports as default};
//# sourceMappingURL=es-ES.mjs.map
